<template>
	<div id="wrapper">
		<SidebarView :fixedAssets="true" :fixedAssetsVisible="true" :nbvPerBranchReport="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box mb-3">
						<div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
							<h6 class="m-0 fw-bold text-green">NBV per Branch</h6>
							<b-button class="akkurate-green-btn btn-size text-white" :disabled="exporting" @click="exportExcel">
								<b-spinner v-if="exporting" small class="me-1" />
								Export Excel
							</b-button>
						</div>
						<div class="card-body">
							<div class="d-flex flex-wrap align-items-center gap-3 mb-3">
								<b-form-checkbox v-model="excludeDisposed">
									Exclude disposed (default ON)
								</b-form-checkbox>
								<b-button class="akkurate-green-btn btn-size text-white" @click="load">
									<font-awesome-icon class="me-1" :icon="['fas', 'rotate']" />
									Refresh
								</b-button>
							</div>

							<div v-if="error" class="alert alert-danger py-2 small mb-2">{{ error }}</div>

							<b-table
								striped
								bordered
								responsive
								:busy="busy"
								:items="rows"
								:fields="fields"
								show-empty
								class="table_text_size"
							/>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>
		<ChatBot />
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
import ApiService from "@/core/services/api.service";

export default {
	name: "NbvPerBranchReport",
	components: { SidebarView, TopbarView, ChatBot },
	data() {
		return {
			busy: false,
			exporting: false,
			error: "",
			excludeDisposed: true,
			rows: [],
			fields: [
				{ key: "branch", label: "Branch" },
				{ key: "total_assets", label: "Assets" },
				{ key: "purchase_cost_total", label: "Purchase cost" },
				{ key: "accumulated_depreciation_total", label: "Acc. depreciation" },
				{ key: "net_book_value_total", label: "NBV" },
			],
		};
	},
	created() {
		this.load();
	},
	methods: {
		params() {
			return { exclude_disposed: this.excludeDisposed ? 1 : 0 };
		},
		async load() {
			this.busy = true;
			this.error = "";
			this.$Progress.start();
			try {
				const res = await ApiService.query("/reports/assets/nbv-per-branch", { params: this.params() });
				const body = res.data;
				this.rows = body.data || body || [];
			} catch (e) {
				this.rows = [];
				this.error = e.response?.data?.message || "Could not load NBV per branch.";
			} finally {
				this.busy = false;
				this.$Progress.finish();
			}
		},
		async exportExcel() {
			this.exporting = true;
			this.error = "";
			try {
				const res = await ApiService.query("/reports/assets/nbv-per-branch/export-excel", { params: this.params() });
				const url = res.data?.download_url;
				if (url) {
					window.open(url, "_blank", "noopener,noreferrer");
					toast.fire({ icon: "success", title: res.data?.message || "Export ready" });
				} else {
					this.error = "Export did not return a download URL.";
				}
			} catch (e) {
				this.error = e.response?.data?.message || "Export failed.";
			} finally {
				this.exporting = false;
			}
		},
	},
};
</script>

